var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _rect9, _rect10, _rect11, _path3, _path4, _rect12, _rect13, _rect14, _path5, _path6, _rect15, _circle, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNftDark = function SvgNftDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 128,
    height: 128,
    rx: 64,
    fill: "#1D192D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 5.75,
    width: 148.5,
    height: 148.5,
    rx: 74.25,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 139,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 12,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 31,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 137,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 64,
    height: 80,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 40.75,
    width: 62.5,
    height: 78.5,
    rx: 9.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 50A9.25 9.25 0 0 1 30 40.75h44A9.25 9.25 0 0 1 83.25 50v53.25h-62.5V50Z",
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.56 69.72a2.591 2.591 0 0 0 3.635-.65 2.66 2.66 0 0 0-.638-3.677 2.591 2.591 0 0 0-3.635.65 2.66 2.66 0 0 0 .639 3.677Zm1.58 11.293a.003.003 0 0 0-.001-.004l-2.675-.01c-1.046-.005-1.6-1.238-.91-2.024l3.817-4.348a1.781 1.781 0 0 1 2.685.009c.707.815 1.97.82 2.683.01l2.873-3.269a2 2 0 0 1 3.012.01l5.531 6.368c1.127 1.297.202 3.317-1.516 3.311l-15.496-.049a.003.003 0 0 1-.002-.004Z",
    fill: "#56516A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 110,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#322E43"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 44,
    width: 64,
    height: 80,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 116.75,
    y: 40.75,
    width: 62.5,
    height: 78.5,
    rx: 9.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.75 50a9.25 9.25 0 0 1 9.25-9.25h44a9.25 9.25 0 0 1 9.25 9.25v53.25h-62.5V50Z",
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.561 69.72a2.592 2.592 0 0 0 3.635-.65 2.66 2.66 0 0 0-.639-3.677 2.592 2.592 0 0 0-3.635.65 2.66 2.66 0 0 0 .639 3.677Zm1.58 11.293c.001-.002 0-.004-.002-.004l-2.675-.01c-1.046-.005-1.601-1.238-.911-2.024l3.819-4.348a1.78 1.78 0 0 1 2.684.009c.707.815 1.971.82 2.684.01l2.872-3.269a2 2 0 0 1 3.012.01l5.531 6.368c1.127 1.297.202 3.317-1.516 3.311l-15.496-.049c-.002 0-.004-.002-.002-.004Z",
    fill: "#56516A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 110,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#322E43"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 56.125,
    y: 35.9,
    width: 78,
    height: 98,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 61.75,
    y: 31.75,
    width: 76.5,
    height: 96.5,
    rx: 9.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.75 41A9.25 9.25 0 0 1 71 31.75h58a9.25 9.25 0 0 1 9.25 9.25v67.65h-76.5V41Z",
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.715 67.407a3.148 3.148 0 0 0 4.43-.796c1.008-1.464.66-3.481-.779-4.505a3.148 3.148 0 0 0-4.43.797c-1.008 1.463-.66 3.48.779 4.504Zm1.925 13.834a.003.003 0 0 0-.002-.005l-3.26-.013c-1.277-.005-1.957-1.51-1.116-2.471l4.785-5.478a2 2 0 0 1 3.02.01l.25.29a2 2 0 0 0 3.02.01l3.955-4.52a2 2 0 0 1 3.019.009l7.715 8.929c1.122 1.298.196 3.313-1.519 3.308l-19.865-.064a.003.003 0 0 1-.002-.005Z",
    fill: "#56516A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 68.313,
    y: 116.75,
    width: 39,
    height: 4.9,
    rx: 2.45,
    fill: "#322E43"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 80,
    fill: "url(#nft-dark_svg__a)",
    fillOpacity: 0.04
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "nft-dark_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.552 80.552) scale(79.4483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6695FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6695FF",
    stopOpacity: 0
  })))));
};

export { SvgNftDark as ReactComponent };
export default "data:image/svg+xml;base64,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";